import React from "react";

export function Logo({ size = 40, showText = true, light = false }) {
  return (
    <div className="flex items-center gap-2" data-testid="brand-logo">
      <img
        src="/logo.png"
        alt="Pepperonni Market"
        style={{ width: size, height: size }}
        className="rounded-xl object-cover shrink-0"
      />
      {showText && (
        <div className="leading-tight">
          <div className={`font-extrabold tracking-tight text-[15px] ${light ? "text-white" : "text-[#122117]"}`}>
            Pepperonni <span className="text-[#C0392B]">Market</span>
          </div>
          <div className={`text-[10px] font-medium ${light ? "text-white/80" : "text-[#6B8375]"}`}>
            Quality Foods, Delivering Trust
          </div>
        </div>
      )}
    </div>
  );
}
